'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Phone = function (_React$Component) {
    _inherits(Phone, _React$Component);

    function Phone(props) {
        _classCallCheck(this, Phone);

        var _this = _possibleConstructorReturn(this, (Phone.__proto__ || Object.getPrototypeOf(Phone)).call(this, props));

        _this.handleReturn = function (code, value, maxLength) {
            var previousValue = (0, _metrixCommon.getReturnElementByCode)(_this.props.return, code);

            var regEx = /^[0-9]*$/;

            if (regEx.test(value) && value.length <= maxLength) {
                _this.props.doSetReturn({ componentCode: _this.props.component.code, code: code, value: value });
            } else {
                if (code === "AreaCode") {
                    _this.refs['2'].refs['2InputRef'].focus();
                }
                if (code === "Number") {
                    _this.refs['3'].refs['3InputRef'].focus();
                }
                _this.props.doSetReturn({ componentCode: _this.props.component.code, code: code, value: previousValue });
            }
        };

        _this.state = {
            validateAreaCode: false,
            validateNumber: false
        };
        return _this;
    }

    _createClass(Phone, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var addExtention = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'AddExtension') !== 'no';

            var areaCodeError = this.state.validateAreaCode && (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'validAreaCode') !== null && !(0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'validAreaCode');
            var numberError = this.state.validateNumber && (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'validNumber') !== null && !(0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'validNumber');

            return _react2.default.createElement(
                _metrixCommon.Grid,
                null,
                _react2.default.createElement(
                    _metrixCommon.Row,
                    { nogutter: true },
                    _react2.default.createElement(
                        _metrixCommon.Column,
                        { xs: 12, md: 3, nogutterleft: true, nogutter: this.props.mobile },
                        _react2.default.createElement(_metrixCommon.Input, { value: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'AreaCode'),
                            id: '1',
                            ref: '1',
                            changeEvent: function changeEvent(value) {
                                return _this2.handleReturn('AreaCode', value, 3);
                            },
                            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AreaCode' }),
                            placeholder: '555',
                            onBlur: function onBlur() {
                                return _this2.setState({ validateAreaCode: true });
                            },
                            error: areaCodeError,
                            type: 'number',
                            disableArrow: true
                        })
                    ),
                    _react2.default.createElement(
                        _metrixCommon.Column,
                        { xs: 12, md: addExtention ? 6 : 9, nogutter: this.props.mobile, nogutterright: !addExtention },
                        _react2.default.createElement(_metrixCommon.Input, { value: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Number'),
                            id: '2',
                            ref: '2',
                            changeEvent: function changeEvent(value) {
                                return _this2.handleReturn('Number', value, 7);
                            },
                            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Number' }),
                            placeholder: '1234567',
                            top: this.props.mobile && _metrixCommon.Sizes.sm,
                            onBlur: function onBlur() {
                                return _this2.setState({ validateNumber: true });
                            },
                            error: numberError,
                            type: 'number',
                            disableArrow: true
                        })
                    ),
                    addExtention && _react2.default.createElement(
                        _metrixCommon.Column,
                        { xs: 12, md: 3, nogutterright: true, nogutter: this.props.mobile },
                        _react2.default.createElement(_metrixCommon.Input, { value: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Extension'),
                            id: '3',
                            ref: '3',
                            changeEvent: function changeEvent(value) {
                                return _this2.handleReturn('Extension', value, 5);
                            },
                            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Extension' }),
                            placeholder: '555',
                            top: this.props.mobile && _metrixCommon.Sizes.sm,
                            optional: true,
                            type: 'number',
                            disableArrow: true
                        })
                    )
                )
            );
        }
    }]);

    return Phone;
}(_react2.default.Component);

exports.default = Phone;